const MONTHS = {
  janvier: 0,
  fevrier: 1,
  février: 1,
  mars: 2,
  avril: 3,
  mai: 4,
  juin: 5,
  juillet: 6,
  aout: 7,
  août: 7,
  septembre: 8,
  octobre: 9,
  novembre: 10,
  decembre: 11,
  décembre: 11,
};

function parseActualiteDate(value) {
  if (!value) {
    return 0;
  }

  const text = String(value).trim().toLowerCase();
  const numericDate = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);

  if (numericDate) {
    const [, day, month, year] = numericDate;
    return new Date(Number(year), Number(month) - 1, Number(day)).getTime();
  }

  const frenchDate = text.match(/^(\d{1,2})\s+([a-zéûôîàèùç]+)\s+(\d{4})$/i);

  if (frenchDate) {
    const [, day, month, year] = frenchDate;
    return new Date(Number(year), MONTHS[month] ?? 0, Number(day)).getTime();
  }

  return Date.parse(value) || 0;
}

export function sortActualitesByDate(actualites = []) {
  return [...actualites].sort((first, second) => parseActualiteDate(second.date) - parseActualiteDate(first.date));
}
